const getNextMonday = inputDate => {
  // FIXME: Make sure this is Monday
  const monday = inputDate instanceof Date ? inputDate : new Date(inputDate);
  const nextMonday = new Date(monday.getTime() + 7 * 24 * 60 * 60 * 1000);
  return nextMonday;
};

export default getNextMonday;
